<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, computed, } from 'vue';
import { useStore } from 'vuex';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { postInfo, postSubmit } from '@/apis/applicantInsuredNameChange';
import { useRoute } from 'vue-router';
import router from '@/router';
import routeName from '@/router/constant';
import Loading from '@/components/Loading.vue';

const route = useRoute();
const store = useStore();
const code = route.meta.code;
const isLoading = ref(false);

// 判斷是否要保人、被保險人兩者ID相同
const isSame = ref(true);

// 要保人姓名
const applicant = ref({
    checked: !isSame.value,
    name: {
        key: '要保人',
        value: '' // 取得資料的公用程式要保人是insName 被保人是name
    },
    newName: {
        key: '要保人新姓名',
        value: '',
        placeholder: '請填寫新的要保人名稱',
        disabled: false
    }
});

// 被保險人姓名
const insurant = ref({
    checked: !isSame.value,
    name: {
        key: '被保險人',
        value: '' // 取得資料的公用程式要保人是insName 被保人是name
    },
    newName: {
        key: '被保險人新姓名',
        value: '',
        placeholder: '請填寫新的被保險人名稱',
        disabled: false
    }
});

const infoBox = ref({
    title: '',
    visble: false,
    applList: [],
    insList: [],
    applAndInsList: []
});

const applicantPolicyList = computed(() => {
    return infoBox.value.applList.filter(p => p.insName !== applicant.value.newName.value)
})

const insurantPolicyList = computed(() => {
    return infoBox.value.insList.filter(p => p.name !== insurant.value.newName.value)
})

// 取得要被保人資料
const getApplAndInsInfo = async () => {
    try {
        const result = await postInfo();
        infoBox.value.insList = result.data.insuredVoList;
        infoBox.value.applList = result.data.policyVoList;
    } catch (error) {
        console.log(error);
    }
};

const initData = async () => {
    const storedData = store.state?.services?.changeItemsResult['130']
    if (storedData) {
        applicant.value = storedData.applicant;
        insurant.value = storedData.insurant;
        infoBox.value.applList = storedData.applList;
        infoBox.value.insList = storedData.insList;
        isSame.value = storedData.isSame;
        // 避免資料遺留
        store.dispatch('services/setChangeItemsResult', { code, value: null });
    } else {
        applicant.value.name.value = store.state.policy.policy.insName;
        insurant.value.name.value = store.state.policy.policy.name;
        isSame.value = store.state.policy.policy.insId === store.state.policy.policy.id;
        await getApplAndInsInfo();
    }
}
initData();

const nextPageButtonDisabled = computed(() => {

    let hasApplicant;
    let hasInsurant;

    if (isSame.value) {
        hasApplicant = applicant.value.newName.value;
        hasInsurant = insurant.value.newName.value;
        return !(hasApplicant && hasInsurant);
    } else {
        hasApplicant = (applicant.value.checked) && applicant.value.newName.value;
        hasInsurant = (insurant.value.checked) && insurant.value.newName.value;
        return !(hasApplicant || hasInsurant);
    }

});

const checkInputText = (e, item) => {
    if (isSame.value) {
        const _Obj = (item === applicant.value) ? (insurant.value) : (applicant.value);
        if (e.target.value) {
            if (!(_Obj.newName.disabled)) {
                _Obj.newName.disabled = true;
            }
        } else {
            if (_Obj.newName.disabled) {
                _Obj.newName.disabled = false;
            }
        }
        _Obj.newName.value = e.target.value;
    }
};

const goNextPage = () => {
    // if (isSame.value) {
    //     infoBox.value.applList = infoBox.value.applAndInsList.filter(item => item.insName === applicant.value.name.value);
    //     infoBox.value.insList = infoBox.value.applAndInsList.filter(item => item.name === insurant.value.name.value);
    // } else {
    //     infoBox.value.applList = infoBox.value.applAndInsList.filter(item => item.insName === applicant.value.name.value && applicant.value.checked);
    //     infoBox.value.insList = infoBox.value.applAndInsList.filter(item => item.name === insurant.value.name.value && insurant.value.checked);
    // }

    infoBox.value.visble = ((isSame.value || applicant.value.checked) && applicantPolicyList.value?.length > 0) || ((isSame.value || insurant.value.checked) && insurantPolicyList.value?.length > 0);

    // if (infoBox.value.applList.length > 0 && infoBox.value.insList.length > 0) {
    //     infoBox.value.title = "因以下保單有相同要保人與被保險人，將一併辦理姓名變更";
    // } else if (infoBox.value.applList.length > 0) {
    //     infoBox.value.title = "以要保人ID於本公司有以下保單號碼，將一併辦理要保人姓名變更";
    // } else if (infoBox.value.insList.length > 0) {
    //     infoBox.value.title = "以被保險人ID於本公司有以下保單號碼，將一併辦理被保險人姓名變更";
    // }

    if (!infoBox.value.visble) {
        submit();
    }
};

const infoBoxOkHandel = () => {
    submit();
};

const submit = () => {
    isLoading.value = true;
    // submit時 name是要保人 ins是被保人
    const request = {
        name: isSame.value || applicant.value.checked ? applicant.value.newName.value : '',
        insuredname: isSame.value || insurant.value.checked ? insurant.value.newName.value : '',
    };
    postSubmit(request).then(res => {
        const storeData = {
            applicant: applicant.value,
            insurant: insurant.value,
            applList: infoBox.value.applList,
            insList: infoBox.value.insList,
            isSame: isSame.value,
        }
        store.dispatch('services/setChangeItemsResult', { code, value: storeData });
        router.push({ name: routeName.CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_CONFIRM });
    }).catch(ex => {
        if (ex?.data?.errorCode === 'InitTransaction.Check') {
            openPopup(ex?.data?.errorMessage, () => {
                router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
            });
            return;
        }
    }).finally(() => {
        isLoading.value = false;
    })
};
</script>

<template>
    <div>
        <Layout
            :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">

            <div class="pt-2 pb-6">
                <Process :steps="['選擇保單', '填寫內容', '確認資料', '視訊預約',]" :index="1"></Process>
            </div>

            <div class="pb-8">
                <h2 class="font-bold text-2xl pb-2">
                    填寫欲變更的姓名
                </h2>
                <p v-if="isSame">若其餘保單有要保人、被保險人相同姓名，將一併辦理變更</p>
                <p v-else>若其餘保單有相同姓名，將一併辦理姓名變更</p>
            </div>

            <div class="pb-4">

                <CaseBox slotClass="p-0" :class="{ 'border border-[#0093C1]': !isSame && item.checked }"
                    :key="item.name.key" v-for="item in [applicant, insurant]">
                    <div>
                        <label class="block p-4 font-bold">
                            <input class="align-text-bottom mr-2" type="checkbox" v-model="item.checked" v-if="!isSame">
                            {{ item.name.key }} <span v-if="item.name.key">：</span>{{ item.name.value }}
                        </label>
                    </div>
                    <div class="pb-4 px-4" v-show="isSame || item.checked">
                        <div class="pb-2 font-bold">{{ item.newName.key }}</div>
                        <input type="text" :placeholder="item.newName.placeholder" v-model="item.newName.value"
                            :disabled="item.newName.disabled" @input="(e) => { checkInputText(e, item) }" />
                    </div>
                </CaseBox>
            </div>
            <template v-slot:bottom>
                <button
                    class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :disabled="nextPageButtonDisabled" @click="goNextPage">下一步</button>
            </template>
            <Loading :is-loading="isLoading" />
        </Layout>
        <InfoBox v-show="infoBox.visble" :closeHandel="() => { infoBox.visble = false; }" :title="infoBox.title"
            :okHandel="infoBoxOkHandel" buttonText="我知道了">
            <!-- <div class="font-bold" v-if="infoBox.applList.length > 0 && applicant.checked">相同要保人之保單：</div> -->
            <div class="font-bold pb-2 text-center"
                v-if="applicantPolicyList.length > 0 && (isSame || applicant.checked)">
                以要保人ID於本公司有以下保單號碼，將一併辦理要保人姓名變更</div>
            <ul class="pl-6 pb-2 list-disc" v-if="isSame || applicant.checked" v-for="item in applicantPolicyList"
                :key="item.policyNo">
                <li>{{ item.fullPolicyNo }}<br>{{ item.itemName }}</li>
            </ul>
            <!-- <div class="font-bold" v-if="infoBox.insList.length > 0 && insurant.checked">相同被保險人之保單：</div> -->
            <div class="font-bold pb-2 text-center"
                v-if="insurantPolicyList.length > 0 && (isSame || insurant.checked)">
                以被保險人ID於本公司有以下保單號碼，將一併辦理被保險人姓名變更</div>
            <ul class="pl-6 pb-2 list-disc" v-if="isSame || insurant.checked" v-for="item in insurantPolicyList"
                :key="item.policyNo">
                <li>{{ item.fullPolicyNo }}<br>{{ item.itemName }}</li>
            </ul>
        </InfoBox>
    </div>
</template>
<style scoped></style>
